import { LitElement, html, css } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

class TooltipElement extends LitElement {
    static styles = css`
    .tooltip {
      position: relative;
      display: inline-block;
    }

    .tooltip .tooltiptext {
      font-size: 12px;
      visibility: hidden;
      background-color: black;
      color: #fff;
      text-align: left;
      border-radius: 6px;
      padding: 5px;
      position: absolute;
      z-index: 1;
      bottom: 125%;
      left: 50%;
      transform: translateX(-50%);
      white-space: pre-wrap;
      min-width: 300px;
      max-width: 90vw; /* Add max-width to ensure it doesn't exceed viewport width */
    }

    .tooltip:hover .tooltiptext {
      visibility: visible;
    }
  `;

    static properties = {
        text: { type: String },
    };

    constructor() {
        super();
        this.text = 'Tooltip text';
    }

    firstUpdated() {
        requestAnimationFrame(() => {
            const fontAwesomeStyle = document.querySelector(
                "link[rel='stylesheet'][data-name='fontawesomev6']"
            );
            if (fontAwesomeStyle) {
                const fontAwesomeStyleClone = fontAwesomeStyle.cloneNode(true);
                fontAwesomeStyleClone.removeAttribute('disabled');
                this.shadowRoot.insertBefore(fontAwesomeStyleClone, this.shadowRoot.firstChild);
            }
            this.adjustTooltipPosition();
        });
    }

    adjustTooltipPosition() {
        requestAnimationFrame(() => {
            const tooltip = this.shadowRoot.querySelector('.tooltiptext');
            const tooltipRect = tooltip.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            // ツールチップの幅がビューポートの幅を超える場合、幅を調整して中央表示
            if (tooltipRect.width > viewportWidth) {
                tooltip.style.width = `${viewportWidth * 0.9}px`; // 画面幅の90%に設定
                tooltip.style.left = '50%';
                tooltip.style.transform = 'translateX(-50%)';
            } else {
                // 幅を超えていない場合の横方向の調整
                if (tooltipRect.right > viewportWidth) {
                    // ツールチップの右端がビューポートからはみ出る場合
                    const overflowRight = tooltipRect.right - viewportWidth;
                    tooltip.style.left = `${tooltip.offsetLeft - overflowRight}px`;
                } else if (tooltipRect.left < 0) {
                    // ツールチップの左端がビューポートからはみ出る場合
                    const parentLeft = this.parentNode.getBoundingClientRect().left
                    tooltip.style.left = `${tooltip.offsetLeft - tooltipRect.left + parentLeft}px`;
                }
            }

            // 縦方向の調整
            if (tooltipRect.top < 0) {
                tooltip.style.bottom = 'auto';
                tooltip.style.top = '125%';
            } else if (tooltipRect.bottom > viewportHeight) {
                tooltip.style.top = 'auto';
                tooltip.style.bottom = '125%';
            }
        });
    }


    showTooltip() {
        const tooltip = this.shadowRoot.querySelector('.tooltiptext');
        tooltip.style.visibility = 'visible';
        this.adjustTooltipPosition();
    }

    hideTooltip() {
        const tooltip = this.shadowRoot.querySelector('.tooltiptext');
        tooltip.style.visibility = 'hidden';
    }

    render() {
        return html`
      <span class="tooltip" 
        @mouseenter="${this.showTooltip}" 
        @mouseleave="${this.hideTooltip}"
        @touchstart="${this.showTooltip}"
        @touchend="${this.hideTooltip}">
        <slot name="tooltip-trigger"><i class="fa-solid fa-circle-question" style="color: #7a7a7a;"></i></slot>
        <span class="tooltiptext" style="visibility: hidden;">${unsafeHTML(this.text)}</span> 
      </span>
    `;
    }
}

customElements.define('tooltip-element', TooltipElement);
